/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Joy Ai V2',
  definitions: {
    '64': {
      viewBox: '0 0 64 64',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.4599 48.6382L42.6773 45.6739C45.1145 39.7397 49.8259 35.0283 55.7601 32.5911L58.7244 31.3736C59.3032 31.1359 59.3032 30.3163 58.7244 30.0786L55.7601 28.8612C49.8259 26.424 45.1145 21.7125 42.6773 15.7784L41.4599 12.8141C41.2222 12.2353 40.4025 12.2353 40.1648 12.8141L38.9474 15.7784C36.5102 21.7125 31.7988 26.424 25.8646 28.8612L22.9003 30.0786C22.3215 30.3163 22.3215 31.1359 22.9003 31.3736L25.8646 32.5911C31.7988 35.0283 36.5102 39.7397 38.9474 45.6739L40.1648 48.6382C40.4025 49.2169 41.2222 49.2169 41.4599 48.6382ZM15.331 10.9448C16.5496 13.9119 18.9053 16.2676 21.8724 17.4862L23.2264 18.0423C23.7225 18.2461 23.7225 18.9486 23.2264 19.1523L21.8724 19.7084C18.9053 20.927 16.5496 23.2828 15.331 26.2498L14.7749 27.6039C14.5712 28.0999 13.8686 28.0999 13.6649 27.6039L13.1088 26.2498C11.8902 23.2828 9.53446 20.927 6.56739 19.7084L5.21336 19.1523C4.71729 18.9486 4.71729 18.2461 5.21336 18.0423L6.56739 17.4862C9.53446 16.2676 11.8902 13.9119 13.1088 10.9448L13.6649 9.5908C13.8686 9.09473 14.5712 9.09473 14.7749 9.5908L15.331 10.9448ZM7.99533 18.5973C10.7025 19.9244 12.8928 22.1147 14.2199 24.8219C15.547 22.1147 17.7373 19.9244 20.4444 18.5973C17.7373 17.2702 15.547 15.0799 14.2199 12.3728C12.8928 15.0799 10.7025 17.2702 7.99533 18.5973ZM24.1885 42.9456C25.0009 44.9236 26.5714 46.4941 28.5495 47.3065L29.5824 47.7307C29.9958 47.9005 29.9958 48.486 29.5824 48.6558L28.5495 49.08C26.5714 49.8924 25.0009 51.4629 24.1885 53.4409L23.7643 54.4739C23.5945 54.8872 23.0091 54.8872 22.8393 54.4739L22.4151 53.4409C21.6027 51.4629 20.0322 49.8924 18.0541 49.08L17.0212 48.6558C16.6078 48.486 16.6078 47.9005 17.0212 47.7307L18.0541 47.3065C20.0322 46.4941 21.6027 44.9236 22.4151 42.9456L22.8393 41.9127C23.0091 41.4993 23.5945 41.4993 23.7643 41.9127L24.1885 42.9456ZM23.3018 44.7527C24.134 46.1757 25.3193 47.3611 26.7423 48.1933C25.3193 49.0254 24.134 50.2108 23.3018 51.6338C22.4696 50.2108 21.2843 49.0254 19.8613 48.1932C21.2843 47.3611 22.4696 46.1757 23.3018 44.7527ZM40.8124 15.449L40.4274 16.3862C37.8278 22.716 32.8022 27.7415 26.4725 30.3412L25.5352 30.7261L26.4725 31.1111C32.8022 33.7107 37.8278 38.7362 40.4274 45.066L40.8124 46.0033L41.1973 45.066C43.7969 38.7362 48.8225 33.7107 55.1522 31.1111L56.0895 30.7261L55.1522 30.3412C48.8225 27.7416 43.7969 22.716 41.1973 16.3862L40.8124 15.449ZM23.5081 29.8936C23.5087 29.8938 23.5093 29.8941 23.5099 29.8943L23.5081 29.8936ZM23.5095 31.5581C23.509 31.5583 23.5086 31.5585 23.5081 31.5586L23.5095 31.5581Z"
            fill="url(#paint0_linear_40567_12940)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_40567_12940"
              x1="4.84131"
              y1="32.0013"
              x2="50.777"
              y2="33.3873"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#25AFFA" />
              <stop
                offset="0.543269"
                stop-color="#4951EF"
              />
              <stop
                offset="1"
                stop-color="#CE54B3"
              />
            </linearGradient>
          </defs>
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
